/* eslint-disable no-param-reassign */

class MForm {
	/** @param {HTMLFormElement} element */
	constructor(element) {
		this.element = element;
		this.errorElement = element.querySelector('.m-form__error');
		this.successElement = element.querySelector('.m-form__success');
		this.submitElement = element.querySelector('button[type="submit"]');

		// load spam prevention
		this.loadSpamPrevention();

		element.addEventListener('submit', (event) => {
			event.preventDefault();
			this.submit();
		});
	}

	loadSpamPrevention() {
		const { element } = this;
		fetch('/api/registration/spam-prevention').then((response) => response.json())
			.then((data) => {
				element.querySelector('input[name="csrf"]').value = data.data.csrf;
				element.querySelector('input[name="date"]').value = data.data.date;
			}).catch((error) => {
				this.showError(error.message);
				console.warn(error);
			});
	}

	submit() {
		const formData = new FormData(this.element);

		this.submitElement.setAttribute('data-state', 'loading');

		// Clear any existing messages
		this.clearError();
		this.clearFieldErrors();

		const formElements = this.element.querySelectorAll('input, textarea, select, button');
		formElements.forEach((element) => {
			element.disabled = true;
		});

		fetch(this.element.action, {
			method: this.element.method,
			credentials: 'same-origin',
			body: formData,
		})
			.then((response) => {
				this.submitElement.removeAttribute('data-state');
				return response.json();
			})
			.then((data) => {
				if (data.status === 'ok') {
					this.showSuccess(data.message);
					this.submitElement.hidden = true;
				} else {
					if (data.key === 'error.registration.validation') {
						this.showFieldErrors(data.details);
					} else {
						this.showError(data?.message ?? 'Fataler Fehler');
					}
					formElements.forEach((element) => {
						element.disabled = false;
					});
				}
			})
			.catch((error) => {
				this.showError(error.message);
				console.warn(error);
				formElements.forEach((element) => {
					element.disabled = false;
				});
			});
	}

	showFieldErrors(/** @type {Object} */ data) {
		Object.keys(data).forEach((key) => {
			const errorElement = this.element.querySelector(`.m-field:has([id="${key}"]) .m-field__error`);
			if (errorElement) {
				errorElement.textContent = data[key];
			} else {
				this.showError(data[key]);
			}
		});
	}

	showError(message) {
		this.errorElement.textContent = message;
		this.errorElement.setAttribute('aria-hidden', 'false');
	}

	clearFieldErrors() {
		this.element.querySelectorAll('.m-field__error').forEach((errorElement) => {
			errorElement.textContent = '';
			errorElement.setAttribute('aria-hidden', 'true');
		});
	}

	clearError() {
		this.errorElement.textContent = '';
		this.errorElement.setAttribute('aria-hidden', 'true');
	}

	showSuccess(message) {
		this.successElement.innerHTML = message;
		this.successElement.setAttribute('aria-hidden', 'false');
	}
}

document.querySelectorAll('.m-form').forEach((_) => new MForm(_));
